module.exports = __webpack_public_path__ + "static/media/marionettes.ce797328.mp3";